import { render, staticRenderFns } from "./ExplorerJMFolder.vue?vue&type=template&id=04b6b6c2&scoped=true&"
import script from "./ExplorerJMFolder.vue?vue&type=script&lang=ts&"
export * from "./ExplorerJMFolder.vue?vue&type=script&lang=ts&"
import style0 from "./ExplorerJMFolder.vue?vue&type=style&index=0&id=04b6b6c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6b6c2",
  null
  
)

export default component.exports